import React from "react"
import { Dimensions, StyleSheet, View } from "react-native"
import { StatusBar } from "expo-status-bar"
import { basePadding } from "@Constants/baseStyles"
import Constants from "expo-constants"
import { Spacer } from "./Space"

const { width, height } = Dimensions.get("screen")
export const ContainerStackScreen = (props) => {
    return (
        <View style={[styles.container, props.style]}>
            {props.children}
            <Spacer height={10} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: basePadding.paddingHorizontal,
        flex: 1,
        backgroundColor: "white"
        // paddingTop: Constants.statusBarHeight
    }
})
